import { Page } from "@whitespace/whitespace-ui";
import { Card } from "react-bootstrap";

const Unknown = () => (
  <Page>
    <Card>
      <Card.Header>
        <h1>Unknown</h1>
      </Card.Header>
      <Card.Body>
        <p>The page you have requested cannot be found.</p>
      </Card.Body>
    </Card>
  </Page>
);

export default Unknown;
